module.exports = __webpack_public_path__ + "static/media/watermark.e4113690.png";